import pushClevertapEvent from 'clevertap/pushClevertapEvent';

export function knowledgeCenterStart() {
  pushClevertapEvent('Knowledge Center Start');
}
